<template>
    <div>
        <div class="flex flex-col space-y-6">
            <div class="text-center">
                <div class="font-semibold mb-1.5">Congratulations!</div>
                You have successfully built your custom wall.
            </div>
            <div>
                <div class="flex flex-col space-y-2.5 max-w-sm">
                    <div>
                        <WizardButton :on-click="restart" theme="dark" class="w-full">Start Over</WizardButton>
                    </div>
                    <div>
                        <WizardButton :on-click="print" theme="gray" class="w-full">Print Summary</WizardButton>
                    </div>
                </div>
            </div>
        </div>

        <hr class="border-gray-30 my-7"/>

        <div class="flex flex-col space-y-8">
            <div class="text-center">
                <p>Click on the links below to download information about your wall.</p>
                <!--          <p>Please select the resources to download with your package.</p>-->
            </div>

            <div class="">

                <ul class="flex flex-col space-y-5">
                    <li v-for="item in filteredItems" :key="item.id" style="margin-top: 5px; line-height: 1.3;">
                        <label class="flex items-center space-x-2">
                            <div class="flex flex-none items-center justify-center border border-gray-30 w-3.5 h-3.5">
                                <input v-model="selectedDocuments" type="checkbox" :value="item.file"
                                       class="w-full h-full cursor-pointer input-check-one border-0 bg-transparent focus:outline-none focus:ring-offset-0 ring-transparent shadow-none focus:ring-0 ring-red-cardinal text-transparent checked:bg-input-checked-one"/>
                            </div>
                            <a :href="`/uploads/resources/${item.file}`" target="_blank"
                               class="select-none text-11px cursor-pointer text-gray-70"
                               style="text-decoration: underline;">{{ item.name }}</a>
                        </label>
                    </li>
                    <li style="margin-top: 5px; line-height: 1.3;">
                        <label class="flex items-center space-x-2">
                            <div class="flex flex-none items-center justify-center border border-gray-30 w-3.5 h-3.5">
                                <input v-model="selectedDocuments" type="checkbox" value="EnergyShield_LEED_Certification_Flyer.pdf"
                                       class="w-full h-full cursor-pointer input-check-one border-0 bg-transparent focus:outline-none focus:ring-offset-0 ring-transparent shadow-none focus:ring-0 ring-red-cardinal text-transparent checked:bg-input-checked-one"/>
                            </div>
                            <a :href="`/uploads/resources/EnergyShield_LEED_Certification_Flyer.pdf`" target="_blank"
                               class="select-none text-11px cursor-pointer text-gray-70"
                               style="text-decoration: underline;">Polyiso Insulation Benefits in LEED Certified Design</a>
                        </label>
                    </li>
                    <li style="margin-top: 5px; line-height: 1.3;">
                        <label class="flex items-center space-x-2">
                            <div class="flex flex-none items-center justify-center border border-gray-30 w-3.5 h-3.5">
                                <input v-model="selectedDocuments" type="checkbox" value="AtlasWall-LimitedWarranty.pdf"
                                       class="w-full h-full cursor-pointer input-check-one border-0 bg-transparent focus:outline-none focus:ring-offset-0 ring-transparent shadow-none focus:ring-0 ring-red-cardinal text-transparent checked:bg-input-checked-one"/>
                            </div>
                            <a :href="`/uploads/resources/AtlasWall-LimitedWarranty.pdf`" target="_blank"
                               class="select-none text-11px cursor-pointer text-gray-70"
                               style="text-decoration: underline;">Atlas Wall-Limited Thermal Warranty</a>
                        </label>
                    </li>
                </ul>

                <!--              <li v-for="item in filteredItems" :key="item.id">
                                  <label class="flex items-center space-x-2">
                                      <div class="flex flex-none items-center justify-center border border-gray-30 w-3.5 h-3.5">
                                          <input checked="checked" type="checkbox" name="check-option" value="option-1"
                                                 class="w-full h-full cursor-pointer input-check-one border-0 bg-transparent focus:outline-none focus:ring-offset-0 ring-transparent shadow-none focus:ring-0 ring-red-cardinal text-transparent checked:bg-input-checked-one"/>
                                      </div>
                                      <div class="select-none text-11px cursor-pointer text-gray-70">{{ item.name }}</div>
                                  </label>
                              </li>
                              <li>
                                  <label class="flex items-center space-x-2">
                                      <div class="flex flex-none items-center justify-center border border-gray-30 w-3.5 h-3.5">
                                          <input checked="checked" type="checkbox" name="check-option" value="option-1"
                                                 class="w-full h-full cursor-pointer input-check-one border-0 bg-transparent focus:outline-none focus:ring-offset-0 ring-transparent shadow-none focus:ring-0 ring-red-cardinal text-transparent checked:bg-input-checked-one"/>
                                      </div>
                                      <div class="select-none text-11px cursor-pointer text-gray-70">Polyiso Insulation Benefits in LEED Certified Design</div>
                                  </label>
                              </li>
                              <li>
                                  <label class="flex items-center space-x-2">
                                      <div class="flex flex-none items-center justify-center border border-gray-30 w-3.5 h-3.5">
                                          <input checked="checked" type="checkbox" name="check-option" value="option-1"
                                                 class="w-full h-full cursor-pointer input-check-one border-0 bg-transparent focus:outline-none focus:ring-offset-0 ring-transparent shadow-none focus:ring-0 ring-red-cardinal text-transparent checked:bg-input-checked-one"/>
                                      </div>
                                      <div class="select-none text-11px cursor-pointer text-gray-70">Atlas Wall-Limited Thermal Warranty
                                      </div>
                                  </label>
                              </li>
                          </ul>-->

            </div>
        </div>
        <div class="flex-shrink">
            <div class="flex items-center space-x-2 px-10 py-8 max-w-sm">
                <div class="w-full">
                    <WizardButton @click="$emit('email')" theme="red" class="w-full">Email Packages</WizardButton>
                </div>
                <div v-show="showEmailModal" class="email-popup w-full h-full fixed inset-0 z-[50]">
                    <div @click="$emit('update:showEmailModal', false)" class="w-full h-full bg-[#0000001a] inset-0 absolute m-0">
                    </div>
                    <div
                        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                        <form @submit.prevent="$emit('send-email', emailAddress)">
                            <div class="mb-4">
                                <label for="wallBuilderEmail" class="block text-sm font-medium text-gray-700">Email Address</label>
                                <input type="email" required id="wallBuilderEmail"
                                       class="w-full mb-[5px] uppercase bg-gray-50 px-[5px] text-gray-suva placeholder:text-gray-suva"
                                       placeholder="EMAIL" :value="emailAddress" @input="$emit('update:emailAddress', $event.target.value)">
                                <button type="submit"
                                        class="cursor-pointer px-4 py-1.5 pt-[10px] text-13px h-[40px] rounded transition-colors text-white text-center bg-red-cardinal hover:bg-red-cardinal-dark w-full">
                                    Submit
                                </button>
                            </div>
                            <div v-if="emailError" class="text-red-500 text-sm mt-2">{{ emailError }}</div>
                            <div v-if="emailSuccess" class="text-green-500 text-sm mt-2">{{ emailSuccess }}</div>
                            <p class="text-12 text-gray-suva mt-4">
                                By providing your email address you agree to Atlas Roofing Corporation emailing you
                                relevant industry information. Atlas will not share your information with any other
                                companies.
                            </p>
                        </form>
                        <button @click="$emit('update:showEmailModal', false)"
                                class="absolute top-[10px] right-[10px] text-gray-suva hover:text-red-cardinal">
                            <svg class="fill-current transition-all duration-300" width="18" height="18"
                                 viewBox="0 0 18 18">
                                <path d="M17.5 1.5L1.5 17.5M1.5 1.5L17.5 17.5"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WizardButton from "../components/WizardButton.vue";

export default {
    components: {WizardButton},
    props: {
        insulation: {
            type: String
        },
        outsideWrb: {
            type: String,
            default: ''
        },
        restart: {
            type: Function
        },
        print: {
            type: Function
        },
        showEmailModal: {
            type: Boolean,
            default: false
        },
        emailAddress: {
            type: String,
            default: ''
        },
        emailError: {
            type: String,
            default: ''
        },
        emailSuccess: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            selectedDocuments: [],
            items: [
                {
                    id: 1,
                    name: 'EnergyShield Data Sheet',
                    file: 'ATL-2104-ES-DataSheet-2.pdf',
                    products: ['energyshield']
                },
                {
                    id: 2,
                    name: 'EnergyShield CGF-Data Sheet',
                    file: 'ATL-2104-ES_CGF-DataSheet_202409.pdf',
                    products: ['energyshield-cgf']
                },
                {
                    id: 3,
                    name: 'EnergyShield Pro-Data Sheet',
                    file: 'ATL-2104-ES_Pro-DataSheet.pdf',
                    products: ['energyshield-pro']
                },
                {
                    id: 4,
                    name: 'EnergyShield Ply Pro-Data Sheet',
                    file: 'ATL-2104-ES_PlyPro-DataSheet.pdf',
                    products: ['energyshield-ply-pro', 'energyshield-ply-pro-wrb']
                },
                {
                    id: 5,
                    name: 'EnergyShield Ply Data Sheet',
                    file: 'ATL-2305-ES_Ply-DataSheet_202409.pdf',
                    products: ['energyshield-ply']
                },
                {
                    id: 6,
                    name: 'EnergyShield XR Data Sheet',
                    file: 'ATL-2218-ES_XR-DataSheet_202401_V2_Update.pdf',
                    products: ['energyshield-xr']
                },
                {
                    id: 7,
                    name: 'EnergyShield CGF Pro-Data Sheet',
                    file: 'ATL-2104-ES_CGF_Pro-DataSheet.pdf',
                    products: ['energy-cgf-pro']
                },
                {
                    id: 8,
                    name: 'EnergyShield Pro & EnergyShield CGF Pro-Install Guide',
                    file: 'ES-Pro_&_CGF-Pro-InstallGuide.pdf',
                    products: ['energy-cgf-pro', 'energyshield-pro']
                },
                {
                    id: 9,
                    name: 'EnergyShield & EnergyShield CGF Install Guide',
                    file: 'ES_&_ES-CGF-InstallGuide.pdf',
                    products: ['energyshield-cgf', 'energyshield']
                },
                {
                    id: 10,
                    name: 'EnergyShield XR Installation Instructions',
                    file: 'ATL-2218-ES_XR-Install-Instructions-USA-062024.pdf',
                    products: ['energyshield-xr']
                },
                {
                    id: 11,
                    name: 'ICC-ES ESR-1375',
                    file: 'ICC-ESR-1375.pdf',
                    products: ['energyshield-cgf', 'energyshield', 'energyshield-pro', 'energyshield-xr']
                },
                {
                    id: 12,
                    name: 'DRJ-TER 2202-01',
                    file: 'DrJ-Report-Atlas-Roofing-Corporation-EnergyShield-Products-2202-01-1.pdf',
                    products: ['energyshield', 'energyshield-cgf', 'energyshield-pro', 'energy-cgf-pro', 'energyshield-xr']
                },
                {
                    id: 13,
                    name: 'Atlas TB 15-Water-Resistive Barrier Compliance',
                    file: 'Atlas-Tech-Bulletin-15-EnergyShield-Products-Compliance-as-a-Water-Resistive-Barrier.pdf',
                    products: ['energyshield', 'energyshield-cgf', 'energyshield-pro', 'energy-cgf-pro', 'energyshield-xr']
                },
                {
                    id: 14,
                    name: 'DRJ-TER 1306-03: NFPA 285 Tested Assemblies',
                    file: 'Atlas-DRJ-TER-1306-03.pdf',
                    products: ['energyshield-pro', 'energy-cgf-pro', 'energyshield-ply-pro', 'energyshield-ply-pro-wrb', 'energyshield-xr']
                },
                {
                    id: 15,
                    name: 'NFPA-285 Detail Drawings',
                    file: 'NFPA-285-DetailDrawings.pdf',
                    products: ['energyshield-pro', 'energy-cgf-pro', 'energyshield-ply-pro', 'energyshield-ply-pro-wrb']
                },
                {
                    id: 16,
                    name: 'DRJ-TER 2305-04: Cladding Attachment Through EnergyShield',
                    file: 'DrJ-Report-Atlas-Roofing-Corporation-EnergyShield-2305-04.pdf',
                    products: ['energyshield-ply-pro', 'energyshield-ply-pro-wrb']
                },
                {
                    id: 17,
                    name: 'Sec 7 2100-EnergyShield Pro Class A Short Form Outline Specifications',
                    file: 'Sec_7_2100-EnergyShield_Pro_Class_A-Short_Form_Outline-Specs.docx',
                    products: ['energy-cgf-pro', 'energyshield-pro', 'energyshield-ply-pro', 'energyshield-ply-pro-wrb']
                },
                {
                    id: 18,
                    name: 'EnergyShield Short Form Outline Specs',
                    file: 'Sec_7_2100-EnergyShield_Short_Form_Outline-Specs.docx',
                    products: ['energyshield', 'energyshield-cgf']
                },
                {
                    id: 19,
                    name: 'EnergyShield XR Short Form Outline Specs',
                    file: '072100_EnergyShield-XR_Short-Form-Spec-2025.docx',
                    products: ['energyshield-xr']
                }
            ],
            // selectedDocuments is now initialized as an empty array above
        }
    },
    computed: {
        filteredItems() {
            return this.items.filter(item => {
                // Always include items that match the insulation
                const matchesInsulation = item.products.includes(this.insulation);

                // For document ID 13, also check if outsideWrb is 'iso-as-wrb'
                if (item.id === 13) {
                    return matchesInsulation && this.outsideWrb === 'iso-as-wrb';
                }

                return matchesInsulation;
            });
        }
    },
    watch: {
        filteredItems: {
            immediate: true,
            handler(newVal) {
                this.updateSelectedDocuments();
            }
        }
    },
    mounted() {
        this.updateSelectedDocuments();
    },
    methods: {
        updateSelectedDocuments() {
            if (this.filteredItems && this.filteredItems.length > 0) {
                const filteredFiles = this.filteredItems.map(item => item.file);
                const staticFiles = [
                    'EnergyShield_LEED_Certification_Flyer.pdf',
                    'AtlasWall-LimitedWarranty.pdf'
                ];

                // Create a Set to avoid duplicates
                const allFiles = new Set([
                    ...filteredFiles,
                    ...staticFiles,
                    ...this.selectedDocuments // Keep any existing selections
                ]);

                this.selectedDocuments = Array.from(allFiles);
            }
        }
    }
}
</script>
